import Button from '@/components/Button.jsx';
import { FiArrowLeft, FiArrowRight } from '@/components/react-icons/main';
import RowV2 from '@/components/v2/RowV2';
import { useState } from 'react';
import getPaginationButtons from './paginationButtons/getPaginationButtons';

const PaginationButtons = ({ total, limit, initialPage, onPageChange }) => {
  const [activePage, setActivePage] = useState(initialPage || 0);
  const totalPages = Math.ceil(total / limit);
  const paginationButtons = getPaginationButtons(activePage, totalPages);

  const handleButtonClick = (n) => {
    if (n === '...') {
      return;
    }
    let newPage = parseFloat(n) - 1;
    if (n === '<') {
      if (activePage < 1) {
        return;
      }
      newPage = activePage - 1;
    }
    if (n === '>') {
      if (activePage >= totalPages - 1) {
        return;
      }
      newPage = activePage + 1;
    }
    setActivePage(newPage);
    onPageChange(newPage);
  };

  if (totalPages <= 1) {
    return null;
  }

  return (
    <RowV2 variant={'header'} className={'borderless pagination-buttons'}>
      <RowV2.Left>
        <Button className="ghost active-text" size={'sm'} icon={FiArrowLeft} disabled={activePage === 0} onClick={() => handleButtonClick('<')} />
        <div className="center">
          {paginationButtons.map((n, idx) => (
            <Button key={idx} className={`ghost ${n === '...' ? 'ellipsis' : ''} ${parseFloat(n) === activePage + 1 ? 'active' : ''}`} size={'sm'} onClick={() => handleButtonClick(n)}>
              {n}
            </Button>
          ))}
        </div>
      </RowV2.Left>
      <RowV2.Right>
        <Button className="ghost active-text" size={'sm'} icon={FiArrowRight} disabled={activePage >= totalPages - 1} onClick={() => handleButtonClick('>')} />
      </RowV2.Right>
    </RowV2>
  );
};

export default PaginationButtons;
